import React, { useEffect, useRef } from "react";
import styles from "./MultiBrand.module.scss";
import LoginImage from "../../assets/loginBack.svg";
import { getSeasonLogo } from "../../utils/season";
import { BrandCard } from "../../components/BrandCard";
import { useAppSelector } from "../../store/store";
import Logout from "../../assets/logout.svg";
import { useDispatch } from "react-redux";
import { logout } from "../../store/slices/auth";
import { useNavigate } from "react-router-dom";

export function MultiBrand() {
  const { brands } = useAppSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleLogout = () => {
    dispatch(logout());
    navigate("/login", { replace: true });
  };

  return (
    <div
      id={'multiBrandPage'}
      className={styles.page}
      style={{backgroundImage: `var(--login-bg-img)`}}
    >
      <div className={styles.body}>
        <img src={getSeasonLogo()} alt="logo" />
        <div className={styles.brands}>
          {brands.map((brand) => {
            return <BrandCard key={brand.brand_id} brand={brand} />;
          })}
        </div>
        <div className={styles.info}>
          <button onClick={handleLogout}>
            Logout <img src={Logout}  alt="logout"/>
          </button>
          <p>Choose brand to login</p>
        </div>
      </div>
    </div>
  );
}
